module.exports = __webpack_public_path__ + "static/media/security.b8c0e673.svg";